import React, { Fragment } from "react";

import IMEAltLogo from "../IME/IMEAltLogo";

const EmployerBackgroundPicsTwo = ({
  user,
  profile,
  setShowEmployerResume,
}) => {
  return (
    <Fragment>
      <div className="profile-background-pics">
        <div className="background-image-container">
          {profile.backgroundimagetwo === "alt_logo.png" ? (
            <div className="profile-alt-logo-container">
              <IMEAltLogo />
              <br />
              <br />
              <br />
              <IMEAltLogo />
              <br />
              <br />
              <br />
              <IMEAltLogo />
            </div>
          ) : (
            <img
              className={"profile-background-image"}
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/innovators/${profile.backgroundimagetwo}`}
              alt="background"
            />
          )}
          <div className="profile-user-info">
            {user && user.user !== profile.user ? (
              <div
                className="profile-user-info-button-blue blue"
                onClick={() => setShowEmployerResume(true)}
              >
                Resume
              </div>
            ) : (
              <div className="profile-user-info-button-blue blue">
                New Applicants
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EmployerBackgroundPicsTwo;
